export default class Hash {
	constructor() {
		this._object = {};
	}

	get(key) {
		return this._object[key];
	}

	add(key, value) {
		this._object[key] = value;
		// this.length = this.length();
		return value;
	}
	set(...args) {
		this.add(...args);
	}

	keys() {
		return Object.keys(this._object);
	}

	length() {
		return this.keys().length;
	}

	first() {
		return this._object[this.keys()[0]];
	}

	last() {
		return this._object[this.keys()[this.length() - 1]];
	}

	each(callback) {
		for (const key in this._object) {
			callback(key, this.get(key));
		}
	}

	filter(callback) {
		let result = new this.constructor();
		this.each((key, value) => {
			if (callback(key, value)) result.set(key, value);
		});
		return result;
	}
}
